import commonApi from './CommonApi.js';
import uploadApi from './UploadApi.js';

export default {	
	uploadAttachment: async (formData) => {
		return await uploadApi().post('/v1/forumThreads/uploadAttachment',
			formData, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/forumThreads', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	downloadAttachment: async (parameters) => {
		return await commonApi().get('/v1/forumThreads/downloadAttachment', { params: parameters, responseType: 'blob' })
			.then((response) => {
				var fileName = parameters.fileName;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	}
}